import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';
import { AddressProfile, FollowAddressItem } from '@src/app/shared/types/address.type';
import { Subject, switchMap, takeUntil } from 'rxjs';
import { AddressService } from '../address.service';

@Component({
    selector: 'app-follow-list',
    templateUrl: './follow-list.component.html',
    styleUrls: ['./follow-list.component.less'],
})
export class FollowListComponent implements OnInit, OnDestroy {
    type: 'follower' | 'following' = 'follower';

    walletAddress: string;

    walletProfile: AddressProfile;
    data: FollowAddressItem[];

    page = 1;
    pageSize = 30;
    isLastPage = false;
    total = 0;

    destroy$ = new Subject();

    get omitLength() {
        return this.commonService.isMobile ? 8 : 30;
    }

    constructor(private activatedRoute: ActivatedRoute, public commonService: CommonService, private addressService: AddressService) {}

    ngOnInit() {
        this.type = this.activatedRoute.snapshot.data['type'];

        this.activatedRoute.params
            .pipe(
                switchMap(params => {
                    this.page = 1;
                    this.isLastPage = false;
                    this.data = null;
                    this.walletAddress = params['address'];
                    this.walletProfile = null;
                    return this.getData();
                }),
                takeUntil(this.destroy$)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.destroy$.next(null);
        this.destroy$.complete();
    }

    getData() {
        return Promise.allSettled([this.addressService.getAddressProfile(this.walletAddress).then(data => (this.walletProfile = data)), this.loadData()]);
    }

    loadData() {
        if (this.isLastPage) return null;

        if (this.type === 'follower') {
            return this.addressService
                .getFollowers(this.walletAddress, this.page, this.pageSize)
                .then(data => {
                    this.data = (this.data || []).concat(data.data);
                    this.isLastPage = data.total <= this.pageSize * this.page;
                    this.page++;
                    this.total = data.total;
                    this.commonService.setAddressIconMap(data.data.map(item => item.wallet_address));
                })
                .catch(err => {
                    this.data = [];
                    this.commonService.errorMessageByResponse(err);
                });
        }

        if (this.type === 'following') {
            return this.addressService
                .getFollowings(this.walletAddress, this.page, this.pageSize)
                .then(data => {
                    this.data = (this.data || []).concat(data.data);
                    this.isLastPage = data.total <= this.pageSize * this.page;
                    this.page++;
                    this.total = data.total;
                    this.commonService.setAddressIconMap(data.data.map(item => item.wallet_address));
                })
                .catch(err => {
                    this.data = [];
                    this.commonService.errorMessageByResponse(err);
                });
        }

        return null;
    }
}
